import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-training-completion-modal',
  templateUrl: './training-completion-modal.component.html',
  styleUrls: ['./training-completion-modal.component.scss'],
})
export class TrainingCompletionModalComponent {
  @Input() isOpen: boolean = false;
  @Input() completedCourses: any[] = [];
  @Input() completedLearningMaps: any[] = [];
  @Output() close = new EventEmitter<void>();

  courseColumns: any[] = [{ field: 'name', header: 'Courses', align: 'left' }];
  learningMapColumns: any[] = [{ field: 'name', header: 'Learning Maps', align: 'left' }];

  get courseRows(): any[] {
    return this.completedCourses.map((c: string) => ({ name: c }));
  }

  get learningMapRows(): any[] {
    return this.completedLearningMaps.map((l: string) => ({ name: l }));
  }
}
